import {
  Box,
  CircularProgress,
  Dialog as MuiDialog,
  styled,
  Typography
} from '@mui/material'
import ClearRoundedIcon from '@mui/icons-material/ClearRounded'
import CheckRoundedIcon from '@mui/icons-material/CheckRounded'

type ProcessingDialogProps = { open: boolean, message?: string }

type SuccessDialogProps = { open: boolean; onClose?: () => void }

const Dialog = styled(MuiDialog)`
  backdrop-filter: blur(12px);
  background: rgba(249, 251, 252, 0.7);
  padding-bottom: 200px;
  top: 64px;

  .MuiDialog-paper {
    border: 1px solid rgba(0, 0, 0, 0.02);
    border-radius: 12px;
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.2);
    overflow-y: inherit;
  }
`

export const ProcessingDialog = ({ open, message }: ProcessingDialogProps) => (
  <Dialog open={open}>
    <Box
      sx={{
        width: { xs: 'calc(100vw - 64px)', sm: 373 },
        alignItems: 'center',
        display: 'flex',
        maxWidth: 373,
        p: 3
      }}
    >
      <CircularProgress size={24} sx={{ color: '#333' }} />
      <Typography sx={{ fontSize: 20, fontWeight: 700, ml: 2 }}>
        {message || 'Processing...'}
      </Typography>
    </Box>
  </Dialog>
)

export const SuccessDialog = ({ open, onClose }: SuccessDialogProps) => (
  <Dialog open={open} onClose={onClose}>
    <Box
      sx={{
        width: { xs: 'calc(100vw - 64px)', sm: 397 },
        display: 'flex',
        maxWidth: 397,
        position: 'relative',
        px: 3,
        py: 4
      }}
    >
      <Box
        onClick={onClose}
        sx={{
          borderRadius: '50%',
          boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.15)',
          cursor: 'pointer',
          display: 'flex',
          position: 'absolute',
          p: 0.25,
          right: 24,
          top: 16,
          transform: 'matrix(1, 0, 0, -1, 0, 0)',
          svg: { width: 22, height: 22 }
        }}
      >
        <ClearRoundedIcon />
      </Box>

      <Box
        sx={{
          height: 'fit-content',
          bgcolor: '#00D193',
          borderRadius: 2,
          color: '#fff',
          display: 'flex',
          p: 0.25,
          svg: { width: 28, height: 28 }
        }}
      >
        <CheckRoundedIcon />
      </Box>

      <Box sx={{ ml: 2 }}>
        <Typography sx={{ fontSize: 20, fontWeight: 700, lineHeight: 1 }}>
          Success
        </Typography>
        <Typography sx={{ color: '#333', lineHeight: 1.4, mt: 1 }}>
          Your event request has been submitted and will be reviewed by the ETA
          TA Staff.
        </Typography>
      </Box>
    </Box>
  </Dialog>
)
